import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: false,
  matchId: "",
  streamData: null,
  openStreamModal: false,
  streamIconClicked: false,
  totalLiveStream: 0,
  extraMatchStreamData: null
};

const stream = createSlice({
  name: "stream",
  initialState,
  reducers: {
    getStreamDataStart: (state, action) => {
      state.loading = true;

      // if (action.payload?.fromLocaiton === "EXTRA_MARKET") {
      //   state.extraMatchStreamData = initialState.extraMatchStreamData;
      // }
      // if (!action.payload?.noLoading) {
      //   state.loading = true;
      // }

      // if (
      //   !action.payload?.fromLocaiton ||
      //   action.payload?.fromLocaiton !== "EXTRA_MARKET"
      // ) {
      //   state.matchId = action.payload.fixture_id;
      //   state.streamData = initialState.streamData;
      // }
      // state.streamIconClicked =
      //   action.payload?.streamIconClicked ?? initialState.streamIconClicked;
    },
    getStreamDataSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      if (action.payload?.isExtraMarketCall) {
        state.extraMatchStreamData = action.payload.streamData;
      } else {
        state.streamData = action.payload;
      }
    },
    getStreamDataFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    setOpenStreamModal: (state) => {
      state.openStreamModal = !state.openStreamModal;
    },
    getLiveStreamCount: () => {},
    getLiveStreamCountSuccess: (state, action) => {
      state.totalLiveStream =
        action.payload?.totalLiveStream || initialState.totalLiveStream;
    },
    getLiveStreamFailure: () => {},
    setStreamClickedState: (state, action) => {
      state.extraMatchStreamData = initialState.extraMatchStreamData;
      state.streamIconClicked =
        action.payload?.streamIconClicked || initialState.streamIconClicked;
    },
    resetLiveStream: (state, action) => {
      if (action.payload?.resetLiveStream) {
        return initialState;
      }
      if (current(state)?.matchId === action.payload?.fixtureId) {
        return initialState;
      }
    }
  }
});

export const {
  getStreamDataStart,
  getStreamDataSuccess,
  getStreamDataFailure,
  setOpenStreamModal,
  getLiveStreamCount,
  getLiveStreamCountSuccess,
  getLiveStreamFailure,
  setStreamClickedState,
  resetLiveStream
} = stream.actions;

export default stream.reducer;
